import { object } from 'prop-types';
import React from 'react';

const ResourceCenterChatBotWrapper = ({ children }) => {
  // const {
  //   requestInfo: { result: commonInfoResult },
  // } = usePrefetch('getResourceCenterCommonInfo');

  // const { triggerChatBot } = useChatbox();

  // useEffect(() => {
  //   // Chatbot trigger Configurable from strapi,
  //   if (commonInfoResult?.chatbotAutoload === true) {
  //     triggerChatBot(
  //       commonInfoResult?.chatbotAutoloadName || GENERIC_CHAT_BOT_TRIGGER,
  //       commonInfoResult?.chatbotAutoloadTime || 25000
  //     );
  //   }
  // }, [commonInfoResult]);

  return <>{children}</>;
};

ResourceCenterChatBotWrapper.propTypes = {
  children: object,
};

export default ResourceCenterChatBotWrapper;
